import React, { useState, useRef } from "react";
import InfoService from "../../../services/info-service";
import "./Auctionsheet.scss";
import { Link, useHistory } from "react-router-dom";

const AuctionSheet = () => {
  const chassisRef = useRef();
  const [data, setData] = useState();
  const infoService = new InfoService();

  const checkChassis = () => {
    const value = chassisRef.current.value;
    infoService.findAuctionSheetNew(value).then((res) => {
      const { data } = res;

      setData(data);
      /*
        data.details = "Toyta"
        data.status = 0 || 1 || 2
      */
    });
  };

  const history = useHistory();

  const goPage = () => {
    if (chassisRef.current.value) {
      let path = "auction-sheet/verify-sheet/" + chassisRef.current.value;
      history.push(path);
    }
  };
  const goPage1 = () => {
    const value = chassisRef.current.value;
    if (value) {
      let path = `https://myauctionsheet.com/find-auction-sheet/${value}`;
      window.location.href = path;
    }
  };
  return (
    <div className="aucSheet py-5">
      <div className="container">
        <div className="row">
          {window.innerWidth < 480 ? (
            <div className="col-sm-5">
              <div className="card border-0" style={{ borderRadius: "6px" }}>
                {data ? (
                  data.status === 0 ? (
                    <div className="not-found p-4 text-center">
                      <img
                        loading="lazy"
                        src={require("../../../assets/Images/notFound.png")}
                        style={{
                          width: "100%",
                          height: "90px",
                          objectFit: "contain",
                        }}
                      />
                      <h4 className="text-danger mt-4">
                        Invalid Chassis Number*{" "}
                      </h4>
                      <p className="mt-2 mb-0" style={{ fontSize: "14px" }}>
                        <b>DID YOU KNOW: </b>Sometimes vehicle record not found
                        due to some unknow factors, then we try with our report+
                        manual service & it will take 24 hours to gather the
                        data.
                      </p>
                    </div>
                  ) : data.status === 1 ? (
                    <div className="p-3 text-center">
                      <img
                        loading="lazy"
                        src={require("../../../assets/Images/text.png")}
                        alt="report+"
                        style={{
                          width: "100%",
                          height: "90px",
                          objectFit: "contain",
                        }}
                      />
                      <h4 className="py-2">Report +</h4>
                      <button
                        className="btn btn-custom"
                        style={{
                          backgroundColor: "var(--orange)",
                          color: "white",
                        }}
                      >
                        Buy Now
                      </button>
                      <p className="mt-2 mb-0" style={{ fontSize: "14px" }}>
                        <b>DID YOU KNOW: </b>Sometimes vehicle record not found
                        due to some unknow factors, then we try with our report+
                        manual service & it will take 24 hours to gather the
                        data.
                      </p>
                    </div>
                  ) : (
                    <div className="p-3 text-center ">
                      <img
                        loading="lazy"
                        style={{
                          width: "100%",
                          height: "120px",
                          objectFit: "contain",
                        }}
                        src={require("../../../assets/Images/auctionsheet/report-found.png")}
                      />
                      <h4 className="py-2">{data.details}</h4>
                      <button
                        className="btn btn-custom"
                        style={{
                          backgroundColor: "var(--orange)",
                          color: "white",
                        }}
                      >
                        Buy Now
                      </button>
                      <p className="mt-2 mb-0" style={{ fontSize: "14px" }}>
                        <b>DID YOU KNOW: </b>Sometimes vehicle record not found
                        due to some unknow factors, then we try with our report+
                        manual service & it will take 24 hours to gather the
                        data.
                      </p>
                    </div>
                  )
                ) : (
                  <img
                    loading="lazy"
                    src={require("../../../assets/Images/auctionsheet/Untitled design (5).png")}
                  />
                )}
              </div>
            </div>
          ) : (
            ""
          )}
          <div className={`col-sm-7`}>
            <h2 className="text-primary">Auction Sheet Verification</h2>
            <p>
              Get the original Auction Sheet Verification by AutoDeals to buy
              the Japenese car with complete peace of mind
            </p>
            <form className="px-0">
              <input
                onChange={(event) =>
                  (event.target.value = event.target.value.toUpperCase())
                }
                ref={chassisRef}
                type="text"
                className="form-control"
                placeholder="Enter Your Chassis No : NHP10-6510598"
              />
              {/* <button type="button" onClick={checkChassis} className="ad-btn ad-btn-secondary-verify mt-0 mt-md-3 mb-4"> */}

              <button
                type="button"
                onClick={goPage1}
                className="adp-btn adp-btn-secondary mt-3 mb-4"
              >
                Verify Your Car Now
              </button>
            </form>
          </div>
          {window.innerWidth > 480 ? (
            <div className="col-sm-5">
              <div
                className="card border-0 mb-2 mt-md-0 mt-4"
                style={{ borderRadius: "6px" }}
              >
                {data ? (
                  data.status === 0 ? (
                    <div className="not-found p-4 text-center">
                      <img
                        loading="lazy"
                        src={require("../../../assets/Images/notFound.png")}
                        style={{
                          width: "100%",
                          height: "90px",
                          objectFit: "contain",
                        }}
                      />
                      <h4 className="text-danger mt-4">
                        Invalid Chassis Number*{" "}
                      </h4>
                      <p className="mt-2 mb-0" style={{ fontSize: "14px" }}>
                        <b>DID YOU KNOW: </b>Sometimes vehicle record not found
                        due to some unknow factors, then we try with our report+
                        manual service & it will take 24 hours to gather the
                        data.
                      </p>
                    </div>
                  ) : data.status === 1 ? (
                    <div className="p-3 text-center">
                      <img
                        loading="lazy"
                        src={require("../../../assets/Images/text.png")}
                        alt="report+"
                        style={{
                          width: "100%",
                          height: "90px",
                          objectFit: "contain",
                        }}
                      />
                      <h4 className="py-2">Report +</h4>
                      <button
                        className="btn btn-custom"
                        style={{
                          backgroundColor: "var(--orange)",
                          color: "white",
                        }}
                      >
                        Buy Now
                      </button>
                      <p className="mt-2 mb-0" style={{ fontSize: "14px" }}>
                        <b>DID YOU KNOW: </b>Sometimes vehicle record not found
                        due to some unknow factors, then we try with our report+
                        manual service & it will take 24 hours to gather the
                        data.
                      </p>
                    </div>
                  ) : (
                    <div className="p-3 text-center ">
                      <img
                        loading="lazy"
                        style={{
                          width: "100%",
                          height: "120px",
                          objectFit: "contain",
                        }}
                        src={require("../../../assets/Images/auctionsheet/report-found.png")}
                      />
                      <h4 className="py-2">{data.details}</h4>
                      <button
                        className="btn btn-custom"
                        style={{
                          backgroundColor: "var(--orange)",
                          color: "white",
                        }}
                      >
                        Buy Now
                      </button>
                      <p className="mt-2 mb-0" style={{ fontSize: "14px" }}>
                        <b>DID YOU KNOW: </b>Sometimes vehicle record not found
                        due to some unknow factors, then we try with our report+
                        manual service & it will take 24 hours to gather the
                        data.
                      </p>
                    </div>
                  )
                ) : (
                  <img
                    loading="lazy"
                    src={require("../../../assets/Images/auctionsheet/Untitled design (5).png")}
                  />
                )}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};
export default AuctionSheet;
